import { KeyboardIcon } from '@/components/Icons/KeyboardIcon';
import { R3imageIcon } from '@/components/Icons/R3imageIcon';
import { R3imageTextIcon } from '@/components/Icons/R3imageTextIcon';
import useGeneratorStore, { GeneratorTypeEnums } from '@/state/generator-store';
import React, { useEffect } from 'react';
import SwitchBgURL from '@/assets/images/generator/switch-bg.png';
import SwitchOrangeBgURL from '@/assets/images/generator/switch-orange-bg.png';
import SwitchToggleURL from '@/assets/images/generator/switch-toggle.png';

interface GeneratorSwitchProps {}

const GeneratorSwitch: React.FC<GeneratorSwitchProps> = () => {
  const [value, setValue] = React.useState(GeneratorTypeEnums.TEXT);
  const { generatorType, setGeneratorType, generatorForm } = useGeneratorStore((state) => ({
    generatorType: state.generatorType,
    setGeneratorType: state.setGeneratorType,
    generatorForm: state.generatorForm,
  }));

  useEffect(() => {
    setValue(generatorType);
  }, []);

  const { setValue: setGeneratorFormValue } = generatorForm ?? {};

  const handleToggle = () => {
    const newValue = value === GeneratorTypeEnums.R3IMAGINE ? GeneratorTypeEnums.TEXT : GeneratorTypeEnums.R3IMAGINE;
    if (newValue === GeneratorTypeEnums.R3IMAGINE) {
      setGeneratorFormValue?.('prompt', '');
    }
    setValue(newValue);
    setGeneratorType(newValue);
  };

  return (
    <div className="flex flex-col justify-center a items-center rounded-lg">
      <KeyboardIcon className="text-gray-400 text-3xl mb-2" />
      <span className="text-gray-400 mb-4 font-pressura-mono text-[0.7rem]">
        <div className="text-center">TEXT INPUT</div>
      </span>
      <div
        onClick={handleToggle}
        className=" cursor-pointer w-[36px] h-[80px] flex justify-center items-center relative hover:brightness-110 transition duration-200"
        style={{
          background: `url(${SwitchBgURL}) no-repeat`,
          backgroundSize: 'cover',
        }}
      >
        <div
          className="w-[26px] h-[70px]"
          style={{
            background: `url(${SwitchOrangeBgURL}) no-repeat`,
            backgroundSize: 'cover',
          }}
        ></div>
        <div
          className="w-[40px] h-[64px] absolute  left-[2px] transition-top duration-300 ease-in-out"
          style={{
            background: `url(${SwitchToggleURL}) no-repeat`,
            backgroundSize: 'cover',
            top: value === GeneratorTypeEnums.R3IMAGINE ? '30px' : '2px',
          }}
        />
      </div>
      <R3imageIcon className="text-gray-400 text-3xl mt-4" />
      <R3imageTextIcon className="text-gray-400 text-3xl mt-4" />
    </div>
  );
};

export default GeneratorSwitch;
